import http from '../../../utils/fetch';
export default {
    baseurl:'/api/swyl/v1',
    //项目列表查询
    page(query){
        return http({
            url: this.baseurl+'/xiangmu/proMain/selectPage',
            method: 'post',
            params: query
        });
    },
    deleteById(id){
        return http({
            url: this.baseurl+'/xiangmu/proMain/deleteById',
            method: 'post',
            params: {id}
        });
    },
    pagechi(query){
        return http({
            url: this.baseurl+'/xiangmu/proMain/chiSelectPage',
            method: 'post',
            params: query
        });
    },
    //项目新建客户名称下拉选
    customerSelect(query){
        return http({
            url: this.baseurl+'/yonghu/bscCustomer/selectAreaList',
            method: 'post',
            data: query
        });
    },
    //产品大类查询
    product1HtSelect(type){
        return http({
            url: this.baseurl+'/productlevel/productLevel/getHtAllId?type='+type,
            method: 'post'
        });
    },

    //产品大类查询
    product1Select(){
        return http({
            url: this.baseurl+'/productlevel/productLevel/getAllId',
            method: 'post'
        });
    },
    //产品小类查询
    product2Select(query){
        return http({
            url: this.baseurl+'/productlevel/productLevel/getAllIds?id='+query,
            method: 'post',
            params: query
        });
    },
    //产品小类详情查询
    product2Detail(query){
        return http({
            url: this.baseurl+'/material/manager/Material/findMaterial',
            method: 'post',
            data: query
        });
    },


    // //产品小类详情查询
    // product2Detail(query){
    //     return http({
    //         url: this.baseurl+'/material/manager/Material/findMaterial',
    //         method: 'post',
    //         data: query
    //     });
    // },

    //保存项目信息
    savePro(query){
        return http({
            url: this.baseurl+'/xiangmu/proMain/creatNewProject',
            method: 'post',
            data: query
        });
    },
    //项目详情页
    proDetail(query){
        return http({
            url: this.baseurl+'/xiangmu/proMain/getProjectById?projectId='+query,
            method: 'post',
            params: query
        });
    },
    //项目详情页
    getShenpiMain(query){
        return http({
            url: this.baseurl+'/xiangmu/proMain/getShenpiMain?projectId='+query,
            method: 'post',
            params: query
        });
    },
    //项目详情页
    getShenpi(query){
        return http({
            url: this.baseurl+'/xiangmu/proPriceOffer/getShenpi?inquiryId='+query,
            method: 'post',
            params: query
        });
    },
	// 报价详情页
	proBaoDetail(query){
		return http({
		    url: this.baseurl+'/xiangmu/proPriceOffer/getAll?projectId='+query,
		    method: 'post',
		    params: query
		});
	},
	// 查看历史报价页
	chakanBaoDetail(inquiryId,productId,usercode){
		return http({
		    url: this.baseurl+'/xiangmu/proPriceOffer/seeHistory',
		    method: 'post',
			params:{inquiryId,productId,usercode}
		});
	},
	// 确认询价
	commitInquiry(query){
		return http({
		    url: this.baseurl+'/xiangmu/proPriceOffer/commitInquiry',
		    method: 'post',
			data:query
		});
	},
    //项目详情页-产品名称
    detailProduct(query){
        return http({
            url: this.baseurl+'/productlevel/productLevel/selectById?id='+query,
            method: 'post',
            params: query
        });
    },
    //项目详情页-招标信息
    bidInfo(query){
        return http({
            url: this.baseurl+'/xiangmu/proBidInfo/getBidDetailByProjectId?projectId='+query,
            method: 'post',
            params: query
        });
    },
    //修改竞标信息
    saveBidWin(query){
        return http({
            url: this.baseurl+'/xiangmu/proBidInfo/creatWonBid',
            method: 'post',
            data: query
        });
    },
    //上传合同
    updateHtStatus(query){
        return http({
            url: this.baseurl+'/xiangmu/proBidInfo/updateHtStatus',
            method: 'post',
            data: query
        });
    },
    //修改竞标信息
    saveBidLoss(query){
        return http({
            url: this.baseurl+'/xiangmu/proBidInfo/creatLostBid',
            method: 'post',
            data: query
        });
    },
    //查询所有供应商的信息
    supplierSearchList(query){
        return http({
            url: this.baseurl+'/test/bscUserInfoSupplierCopy/selectCaiGouList',
            method: 'post',
            data: query
        });
    },
    //查询所有供应商的信息
    selectCaiGouListPage(params){
        return http({
            url: this.baseurl+'/test/bscUserInfoSupplierCopy/selectCaiGouListPage',
            method: 'post',
            params: params
        });
    },
    //发起询价
    saveInquiry(query){
        return http({
            url: this.baseurl+'/xiangmu/proMain/newInquiry',
            method: 'post',
            data: query
        });
    },
    //报价回显
    proDetailOffer(projectId){
        return http({
            url: this.baseurl+'/xiangmu/proMain/getOfferById',
            method: 'post',
            params: {projectId}
        });
    },
    //提价报价
    saveOffer(query){
        return http({
            url: this.baseurl+'/xiangmu/proPriceOffer/updateById',
            method: 'post',
            params: query
        });
    },
    //项目详情页
    proDetailXj(query){
        return http({
            url: this.baseurl+'/xiangmu/proMain/getProjectByIdxj?projectId='+query,
            method: 'post',
            params: query
        });
    },
    //保存中标供应商
    saveXj(query){
        return http({
            url: this.baseurl+'/xiangmu/proPriceInquiry/updateById',
            method: 'post',
            data: query
        });
    },
    //选中的供应商
    supplierByProductId(query) {
        return http({
            url: this.baseurl+'/xiangmu/proPriceInquiry/supplierByProductId',
            method: 'post',
            params: query
        });
    },

    //选中的供应商list
    supplierByProductIdlist(query) {
        return http({
            url: this.baseurl+'/xiangmu/proPriceInquiry/supplierByProductIdlist',
            method: 'post',
            params: query
        });
    },

    //展会审核
    checkExpoxm(query) {
        return http({
            url: this.baseurl+'/xiangmu/proMain/checkExpoxm',
            method: 'post',
            data: query
        });
    },
    //采购项目审核（质量审核）
    checkCaigou(query) {
        return http({
            url: this.baseurl+'/xiangmu/proMain/checkCaigou',
            method: 'post',
            data: query
        });
    },
    //采购项目审核
    projectCGPass(query) {
        return http({
            url: this.baseurl+'/xiangmu/proPriceInquiry/projectCGPass',
            method: 'post',
            data: query
        });
    },
    //展会经销商保存
    saveExhibitionAgent(query) {
        return http({
            url: this.baseurl+'/xiangmu/proMain/saveExhiAgent',
            method: 'post',
            data: query
        });
    },
    //竞品品牌
    comperOption(query) {
        return http({
            url: this.baseurl+'/basic/competitorsInfo/selectList',
            method: 'post',
            data: query
        });
    },
    //重写产品小类查询
    product2OemSelect(query){
        return http({
            url: this.baseurl+'/productlevel/productLevel/getOEMIds?id='+query,
            method: 'post',
            params: query
        });
    },
    //这个是真的查oem，上面那个是查所有
    product2OemSelectReal(query){
        return http({
            url: this.baseurl+'/productlevel/productLevel/getRealOEMIds?id='+query,
            method: 'post',
            params: query
        });
    },
    //自主备货订单获取库发
    product2StockOemSelect(query){
        return http({
            url: this.baseurl+'/productlevel/productLevel/getStockOEMIds?id='+query,
            method: 'post',
            params: query
        });
    },
    //自主备货订单获取库发
    getOEMProduct(query){
        return http({
            url: this.baseurl+'/productlevel/productLevel/getOEMProduct?id='+query,
            method: 'post',
            params: query
        });
    },
	product2NoOemSelect(query){
	    return http({
	        url: this.baseurl+'/productlevel/productLevel/getOEMIds?id='+query,
	        method: 'post',
	        params: query
	    });
	},

    product2NoOemSelectZl(query){
        return http({
            url: this.baseurl+'/productlevel/productLevel/getZlOEMIds?id='+query,
            method: 'post',
            params: query
        });
    },

    htcheck(query) {
        return http({
            url: this.baseurl+'/hetong/bscContract/selectById?id='+query,
            method: 'post',
            data: query
        });
    },
    toshow(pageId,nextShow){
        return http({
            url: '/api/swyl/v1/demo/bscNoviceGuideDetail/isShowNoviceGuide',
            method: 'post',
            params: {pageId,nextShow}
        });
    },
    //报价管理报表
    selectQuotePage(query) {
        return http.post('/api/swyl/v1/demo/projectQuote/selectPage',query);
    },
    getProdectList(projectId){
        return http({
            url: '/api/swyl/v1/xiangmu/proProductInfo/getProdectList',
            method: 'post',
            params: {projectId}
        });
    },
    commitBaojia(v){
        return http({
            url: '/api/swyl/v1/xiangmu/proPriceOffer/commitBaojia',
            method: 'post',
            data: v
        });
    },
    seeHistory(inquiryId,productId){
        return http({
            url: '/api/swyl/v1/xiangmu/proPriceOffer/seeHistory',
            method: 'post',
            params: {inquiryId,productId}
        });
    },
    bohui(v){
        return http({
            url: '/api/swyl/v1/xiangmu/proMain/bohui',
            method: 'post',
            params: v
        });
    },
    pass(v){
        return http({
            url: '/api/swyl/v1/xiangmu/proMain/pass',
            method: 'post',
            params: v
        });
    },
    queryProjectId(inquiryId){
        return http({
            url: '/api/swyl/v1/xiangmu/proMain/queryProjectId',
            method: 'post',
            params: {inquiryId}
        });
    },
////////////------>上海直销，报价
    saveXunjiazu(data){
        return http({
            url: "/api/swyl/v1/product/proGysShanghai/insert",
            method: 'post',
            data: data
        });
    },
    grouplist(params){
        return http({
            url: "/api/swyl/v1/product/proGysShanghai/grouplist",
            method: 'post',
            params: params
        });
    },
    gysbjlistPage(params){
        return http({
            url: "/api/swyl/v1/product/proGysShanghai/gysbjlistPage",
            method: 'post',
            params: params
        });
    },
    commitShanghaiBaojia(data){
        return http({
            url: "/api/swyl/v1/product/proGysShanghai/commitShanghaiBaojia",
            method: 'post',
            data: data
        });
    },
    submitTimeout(v){
        return http({
            url: "/api/swyl/v1/product/proGysShanghai/submitTimeout",
            method: 'post',
            params: v
        });
    },
    pointGys(v){
        return http({
            url: "/api/swyl/v1/product/proGysShanghai/pointGys",
            method: 'post',
            params: v
        });
    },
    selectTender(data){
        return http({
            url: "/api/swyl/v1/hetong/BscSrmTenderController/selectTender",
            method: 'post',
            params: data
        });
    },
    selectTenderDetail(data){
        return http({
            url: "/api/swyl/v1/hetong/BscSrmTenderDetailController/selectTenderDetail",
            method: 'post',
            params: data
        });
    },
    //查询所有供应商的信息
    getAllSupplier(query){
        return http({
            url: this.baseurl+'/test/bscUserInfoSupplierCopy/getAllSupplier?username=' + query,
            method: 'post',
            data: query
        });
    },

    selectProListBySh(query){
        return http({
            url: this.baseurl+'/xiangmu/proMain/selectProListByShPage',
            method: 'post',
            params: query
        });
    },

}
